import localizame from "../../assets/logoLocalizame.png"
import { useFetch } from "../../hooks/useFetch/useFetch";


export const WebFooter = ({color, logo}) => {

    return (
        <footer >
            <div className="web-menu-footer" style={{background:`${color}15`}}>
                <ul>
                    <li>
                        <a style={{color:`${color}`}} href="#inicio">Inicio</a>
                    </li>
                    <li>
                        <a style={{color:`${color}`}} href="#local">Local</a>
                    </li>
                    <li>
                        <a style={{color:`${color}`}} href="#testimonios">Testimonios</a>
                    </li>
                    <li>
                        <a style={{color:`${color}`}} href="#contacto">Contacto</a>
                    </li>
                </ul>
                <div className="logo">
                    <img src={logo} />
                </div>
            </div>

            <div style={{ padding: '20px' }}>
                <p style={{ color: 'grey', margin: 0 }}>Powered By</p>
                <img src={localizame} style={{ maxWidth: '200px' }} />
            </div>
        </footer>
    )
}
